import { render, staticRenderFns } from "./Buy.vue?vue&type=template&id=29bf27b4&scoped=true&lang=pug&"
import script from "./Buy.vue?vue&type=script&lang=js&"
export * from "./Buy.vue?vue&type=script&lang=js&"
import style0 from "./Buy.scss?vue&type=style&index=0&id=29bf27b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bf27b4",
  null
  
)

export default component.exports